module.exports = __webpack_public_path__ + "media/bg.1895dd22.mp4";